<template>
  <div class="ima-filter-toolbar">
    <div class="ima-filter-toolbar__options">
      <slot></slot>
    </div>
    <div class="ima-filter-toolbar__active-filters-panel" v-if="activeFilters && activeFilters.length">
      <b-icon icon="filter_list" size="is-small is-white"></b-icon>

      <div class="ima-filter-toolbar__active-filters">
        <div class="tag ima-filter-toolbar__active-filter" v-for="filter in activeFilters " :key="filter.label ">
          <span>{{filter.label}}</span>
          <button class="delete is-small " @click="filter.remove() "></button>
        </div>
      </div>

      <button class="delete ima-filter-toolbar__remove-all-btn" @click="removeAll() "></button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ima-filter-toolbar',
  props: ['activeFilters'],
  data () {
    return {}
  },
  methods: {
    removeAll () {
      this.activeFilters.forEach(filter => filter.remove())
    }
  }
}
</script>


<style lang="scss">
@import '../scss/settings';
.ima-filter-toolbar {
  background-color: $secondary;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  padding: 0.6rem;
  margin-bottom: 0.8rem;

  .field {
    margin: 0 0.6rem 0 0;

    button {
      .icon {
        color: #dbdbdb;
      }

      &:focus {
        .icon {
          color: currentColor;
        }
      }
    }
  }

  .dropdown .dropdown-menu {
    .dropdown-content {
      padding: 0;
    }
    .dropdown-item {
      &:hover,
      &.is-selected:hover {
        background-color: $highlight;
        color: #fff;
      }
      &.is-selected {
        background-color: inherit;
        color: inherit;
      }
    }
  }

  &__options {
    display: flex;

    a.dropdown-item.is-active {
      background-color: inherit;
      color: inherit;
    }
  }

  &__active-filters-panel {
    background-color: $highlight;
    border-radius: 3px;
    display: flex;
    align-items: center;
    margin: 0.5rem 0 0 0;
    padding: 0.6rem;
  }

  &__active-filters {
    display: flex;
    flex-grow: 1;
    margin: 0 0.5rem;
  }

  &__active-filter {
    background-color: darken($highlight, 8) !important;
    border: 1px solid darken($highlight, 15);
    color: #fff !important;
    cursor: default;
    font-size: 0.8rem;
    font-weight: 600;
    margin-right: 0.5rem;
    padding: 0.8rem;
    user-select: none;
  }

  &__remove-all-btn {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilterToolbar.vue